/**
 * Split mixed text into plain segments and LaTeX segments.
 * Inline math: $...$  Display math: $$...$$
 */
export function splitLatexSegments(str) {
  if (str == null || str === '') {
    return [{ t: 'text', v: '' }];
  }
  const segments = [];
  let i = 0;
  const n = str.length;
  while (i < n) {
    if (str[i] === '$' && str[i + 1] === '$') {
      const close = str.indexOf('$$', i + 2);
      if (close === -1) {
        segments.push({ t: 'text', v: str.slice(i) });
        break;
      }
      segments.push({ t: 'display', v: str.slice(i + 2, close) });
      i = close + 2;
      continue;
    }
    if (str[i] === '$') {
      const close = str.indexOf('$', i + 1);
      if (close === -1) {
        segments.push({ t: 'text', v: str.slice(i) });
        break;
      }
      segments.push({ t: 'inline', v: str.slice(i + 1, close) });
      i = close + 1;
      continue;
    }
    const next = str.indexOf('$', i);
    const end = next === -1 ? n : next;
    if (end > i) {
      segments.push({ t: 'text', v: str.slice(i, end) });
    }
    i = end;
  }
  return segments;
}
